import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { Map, Record } from 'immutable';
import { IBaseCondition, ReadOnlyBaseCondition } from './IBaseCondition';
import { NodeLocationFactory, NodeLocationFactoryFromJS } from './INodeLocation';
import { RuleFlowFactoryFromJS } from './IRuleFlow';

export interface IBaseConfirmationCondition {
	typeName: 'ConfirmationCondition';
}

export interface IConfirmationCondition extends IBaseConfirmationCondition, IBaseCondition {
	typeName: 'ConfirmationCondition';
	messages: IDictionary<string>;
}

export interface ReadOnlyConfirmationCondition
	extends IBaseConfirmationCondition,
		ReadOnlyBaseCondition {
	messages: Map<string, string>;
}

export type ConfirmationCondition = ReadonlyRecord<ReadOnlyConfirmationCondition>;

export const ConfirmationConditionFactory = Record<ReadOnlyConfirmationCondition>({
	id: null,
	name: null,
	typeName: 'ConfirmationCondition',
	loc: NodeLocationFactory(),
	onSuccess: null,
	onFailure: null,
	messages: Map()
});

export const ConfirmationConditionFactoryFromJS = (data: IConfirmationCondition) => {
	return ConfirmationConditionFactory({
		...data,
		messages: Map(data.messages),
		loc: data.loc ? NodeLocationFactoryFromJS(data.loc) : null,
		onSuccess: data.onSuccess ? RuleFlowFactoryFromJS(data.onSuccess) : null,
		onFailure: data.onFailure ? RuleFlowFactoryFromJS(data.onFailure) : null
	});
};
